const textTableList = [
  {
    TEXT: 'เงินเดือน',
    OPERATE_INCOME_TAX: '-',
    PERSONAL_INCOME_TAX: 'อัตราก้าวหน้า',
  },
  {
    TEXT: 'ค่าเช่าอาคาร',
    OPERATE_INCOME_TAX: '5%',
    PERSONAL_INCOME_TAX: '5%',
  },
  {
    TEXT: 'ค่าเช่ารถ',
    OPERATE_INCOME_TAX: '5%',
    PERSONAL_INCOME_TAX: '5%',
  },
  {
    TEXT: 'ค่าซ่อมแซม',
    OPERATE_INCOME_TAX: '3%',
    PERSONAL_INCOME_TAX: '3%',
  },
  {
    TEXT: 'ค่าเบี้ยประกันวินาศภัย',
    OPERATE_INCOME_TAX: '1%',
    PERSONAL_INCOME_TAX: '-',
  },
  {
    TEXT: 'ค่าทำบัญชี',
    OPERATE_INCOME_TAX: '3%',
    PERSONAL_INCOME_TAX: '3%',
  },
  {
    TEXT: 'ค่าสอบบัญชี',
    OPERATE_INCOME_TAX: '3%',
    PERSONAL_INCOME_TAX: '3%',
  },
  {
    TEXT: 'ค่าโฆษณา',
    OPERATE_INCOME_TAX: '2%',
    PERSONAL_INCOME_TAX: '2%',
  },
  {
    TEXT: 'ค่าขนส่ง',
    OPERATE_INCOME_TAX: '3%',
    PERSONAL_INCOME_TAX: '1%',
  },
  {
    TEXT: 'ค่าส่งเสริมการขาย',
    OPERATE_INCOME_TAX: '3%',
    PERSONAL_INCOME_TAX: '3%',
  },
  {
    TEXT: 'ค่าจ้างทำของ',
    OPERATE_INCOME_TAX: '3%',
    PERSONAL_INCOME_TAX: '3%',
  },
  {
    TEXT: 'ค่านายหน้า',
    OPERATE_INCOME_TAX: '3%',
    PERSONAL_INCOME_TAX: 'อัตราก้าวหน้า',
  },
  {
    TEXT: 'ค่าที่ปรึกษากฎหมาย/บัญชี',
    OPERATE_INCOME_TAX: '3%',
    PERSONAL_INCOME_TAX: '3%',
  },
  {
    TEXT: 'เงินปันผล',
    OPERATE_INCOME_TAX: '10%',
    PERSONAL_INCOME_TAX: '10%',
  },
  {
    TEXT: 'ดอกเบี้ยจ่าย',
    OPERATE_INCOME_TAX: '1%',
    PERSONAL_INCOME_TAX: '15%',
  },
]

export default textTableList